import React, {useState} from 'react';
import { useParams } from 'react-router-dom';
import {ApolloClient, gql, HttpLink, InMemoryCache} from "@apollo/client";
import {Helmet, HelmetProvider} from "react-helmet-async";
import companyLogo from "../kantei-logo.svg";
import appLogo from "../kantei-mobile-logo.svg";
import fetch from "cross-fetch";

function NewsPage() {
    const [newsItem, setNewsItem] = useState({
        title: '',
        body: ''
    });
    const { newsHash } = useParams();


    // GraphQLクライアント
    const apolloClient = new ApolloClient({
        link: new HttpLink({
            uri: process.env.REACT_APP_EXT_API_URL + process.env.REACT_APP_API_LATEST,
            fetch
        }),
        cache: new InMemoryCache(),
    });

    const search_query = gql`
        query {
            getNewsDetail(
                userToken: ""
                newsId: "${newsHash}"
            ) {
                title
                body
            }
        }
    `;
    apolloClient
        .query({
            query: search_query
        })
        .then((result) => {
            setNewsItem({
                title: result.data.getNewsDetail.title,
                body: result.data.getNewsDetail.body
            })
        })
        .catch((error) => {
            console.log(error);
        });

    return (
        <HelmetProvider>
            <Helmet>
                <title>カンテイモバイル</title>
            </Helmet>
            <div className="App">
                <div className="App-background">
                    <div className="App-base">
                        <>
                            <div className="App-header">
                                <img src={companyLogo} className="Company-logo" alt="company-logo"/>
                                <img src={appLogo} className="App-logo" alt="company-logo"/>
                            </div>
                            <div className="App-body">
                                <div className="News-container">
                                    <div className="News-title">
                                        {newsItem.title}
                                    </div>
                                    <div className="News-body" dangerouslySetInnerHTML={{__html: newsItem.body}} />
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            </div>
        </HelmetProvider>
    );
}

export default NewsPage;